
import React from 'react';
import { Link } from 'react-router-dom';
import { useInView } from 'react-intersection-observer';
import useCountAnimation from '../../hooks/useCountAnimation';
import mug_example from '../../assets/TAB-TABTOUCH-mug-example.png';
import './MugMaster.css';

const MugMaster = () => {
  const [featureRef, featureInView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });

  const [exampleRef, exampleInView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });

  const features = [
    {
      title: "Smart Account Management",
      description: "Find optimal mug bets across 12 bookmakers to maintain healthy betting patterns",
      icon: "🎯"
    },
    {
      title: "Custom Search",
      description: "Specify both bookmakers, stakes, odds requirements and days ahead for perfect mugging",
      icon: "🔍"
    },
    {
      title: "Loss Minimization",
      description: "Intelligent stake calculation to keep expenses low while maintaining account health",
      icon: "💰"
    }
  ];

  return (
    <div className="conversion-wizard">
      <section className="hero-container">
        <div className="hero-content">
          <h1 className="slide-up">Mug Master</h1>
          <p className="hero-subtitle slide-up-delay">Maintain healthy betting accounts with intelligent mug betting strategies</p>
          <div className="hero-stats slide-up-delay-2">
            <div className="stat">
              <span className="stat-number">{useCountAnimation(15)}<span className="stat-unit">min</span></span>
              <span className="stat-label">Update Frequency</span>
            </div>
            <div className="stat">
              <span className="stat-number">{useCountAnimation(14)}<span className="stat-unit">Days</span></span>
              <span className="stat-label">Scanned Ahead</span>
            </div>
            <div className="stat">
              <span className="stat-number">{useCountAnimation(12)}</span>
              <span className="stat-label">Bookmakers supported</span>
            </div>
          </div>
        </div>
      </section>

      <section className="example-section" ref={exampleRef}>
        <div className={`example-container ${exampleInView ? 'fade-in' : ''}`}>
          <div className="example-content">
            <h2>How It Works</h2>
            <p>Our system identifies optimal mug betting opportunities that help maintain your betting account health. Specify both bookmakers, customize odds requirements, and let us calculate the perfect stake sizes. Keep your pulse on valuable promotions by blending in as a regular bettor with minimal expense.</p>
          </div>
          <div className="example-image">
            <img src={mug_example} alt="Mug Betting Example" />
          </div>
        </div>
      </section>

      <section className="features" ref={featureRef}>
        <div className={`features-grid ${featureInView ? 'features-visible' : ''}`}>
          {features.map((feature, index) => (
            <div className="feature-card" key={index}>
              <div className="feature-icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="cta-section">
        <div className="other-bots">
          <h2>Explore Our Other Tools</h2>
          <p>Complete your matched betting toolkit with our specialized bots</p>
          <div className="bot-links">
            <Link to="/conversion-wizard" className="bot-link">
              <span className="bot-icon">🔄</span>
              <div className="bot-info">
                <h3>Conversion Wizard</h3>
                <p>Transform bonus bets into real cash</p>
              </div>
            </Link>
            <Link to="/betslips-tips" className="bot-link">
              <span className="bot-icon">🎯</span>
              <div className="bot-info">
                <h3>Betslips & Tips</h3>
                <p>Smart bet tracking and analysis</p>
              </div>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MugMaster;
